import { render, staticRenderFns } from "./AssignmentForList.vue?vue&type=template&id=bf34ddc2&scoped=true&"
import script from "./AssignmentForList.vue?vue&type=script&lang=js&"
export * from "./AssignmentForList.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentForList.vue?vue&type=style&index=0&id=bf34ddc2&prod&lang=css&"
import style1 from "./AssignmentForList.vue?vue&type=style&index=1&id=bf34ddc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf34ddc2",
  null
  
)

export default component.exports